var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { computed, makeObservable, observable, runInAction } from 'mobx';
import { AmplifyService } from '@data/api';
import { AmplifyFeature } from '@data/api/types/amplify/features';
import { ScriptData } from '@data/models/amplify';
import Store from '../Store';
export default class Amplify {
    constructor() {
        Object.defineProperty(this, "scriptData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getScriptData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (propertyId) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                if (!propertyId)
                    return;
                // Marketing Insights Service
                const misTypes = [];
                // Amplify Metasearch Connector Service
                const amcsTypes = [];
                (_b = (_a = Store.property.model) === null || _a === void 0 ? void 0 : _a.amplifyFeatures) === null || _b === void 0 ? void 0 : _b.forEach((feature) => {
                    switch (feature) {
                        case AmplifyFeature.Retargeting:
                            misTypes.push(AmplifyFeature.Retargeting);
                            break;
                        case AmplifyFeature.MetasearchAds:
                            amcsTypes.push(AmplifyFeature.MetasearchAds);
                            break;
                        case AmplifyFeature.PMax:
                            amcsTypes.push(AmplifyFeature.PMax);
                            break;
                        default:
                            break;
                    }
                });
                let result = undefined;
                if (misTypes.length) {
                    const misResult = yield AmplifyService.getScriptDataFromMIS({
                        propertyID: propertyId,
                        types: misTypes,
                    });
                    result = {
                        retargeting: misResult.retargeting,
                    };
                }
                if (amcsTypes.length) {
                    const amcsResult = yield AmplifyService.getScriptDataFromAMCS({
                        propertyID: propertyId,
                        types: amcsTypes,
                    });
                    result = Object.assign(Object.assign({}, result), { googleTroas: amcsResult.googleTroas, pmax: amcsResult.pmax });
                }
                if (!result)
                    return;
                runInAction(() => {
                    this.scriptData = result;
                });
                return result;
            })
        });
        this.scriptData = new ScriptData();
        makeObservable(this);
    }
    get isRetargetingEnabled() {
        var _a, _b, _c, _d;
        return !!(((_b = (_a = this.scriptData) === null || _a === void 0 ? void 0 : _a.retargeting) === null || _b === void 0 ? void 0 : _b.advertisableID) &&
            ((_d = (_c = this.scriptData) === null || _c === void 0 ? void 0 : _c.retargeting) === null || _d === void 0 ? void 0 : _d.pixelID));
    }
    get isGoogleTroasEnabled() {
        var _a, _b, _c, _d;
        return !!(((_b = (_a = this.scriptData) === null || _a === void 0 ? void 0 : _a.googleTroas) === null || _b === void 0 ? void 0 : _b.conversionID) &&
            ((_d = (_c = this.scriptData) === null || _c === void 0 ? void 0 : _c.googleTroas) === null || _d === void 0 ? void 0 : _d.conversionLabel));
    }
    get isPMaxEnabled() {
        var _a, _b, _c, _d;
        return !!(((_b = (_a = this.scriptData) === null || _a === void 0 ? void 0 : _a.pmax) === null || _b === void 0 ? void 0 : _b.conversionID) &&
            ((_d = (_c = this.scriptData) === null || _c === void 0 ? void 0 : _c.pmax) === null || _d === void 0 ? void 0 : _d.conversionLabel));
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], Amplify.prototype, "scriptData", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Amplify.prototype, "isRetargetingEnabled", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Amplify.prototype, "isGoogleTroasEnabled", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Amplify.prototype, "isPMaxEnabled", null);
